import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react'
import useAxios from 'axios-hooks'
import { USER_API } from '../../utils/urls'
import { AppContext } from 'src/views/context/app'
import { raiseToast } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'

const RoleplayModal = ({ accountId, onClose }) => {
  const { setLoader } = useContext(AppContext)
  const { updateLogin } = useContext(GlobalContext)
  const [CMSUserData, setCMSUserListData] = useState([])
  const [selectedCMSUserId, setSelectedCMSUserId] = useState('')

  const [{ data: cmsUserList, loading: cmsUserListLoading }, cmsUserListCall] = useAxios(
    {
      url: USER_API + '/cms-user/' + accountId,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: roleplayData, loading: roleplayLoading }, roleplayCall] = useAxios(
    {
      url: USER_API + '/role-play',
      method: 'post',
    },
    { manual: true },
  )

  useEffect(() => {
    if (accountId) {
      cmsUserListCall()
    }
  }, [accountId])

  useEffect(() => {
    setLoader(cmsUserListLoading || roleplayLoading)
  }, [cmsUserListLoading, roleplayLoading])

  useEffect(() => {
    if (cmsUserList && cmsUserList?.success) {
      setCMSUserListData(cmsUserList?.data)
    }
  }, [cmsUserList])

  useEffect(() => {
    if (roleplayData && roleplayData?.success) {
      localStorage.clear()
      localStorage.setItem('sessionId', roleplayData.data.user_session.session_id)
      localStorage.setItem('customer_id', roleplayData.data.user.account)
      localStorage.setItem('accountId', roleplayData.data.user.account)
      updateLogin(roleplayData.data)
      window.location.reload()
    }
  }, [roleplayData])

  const onStart = () => {
    if (!selectedCMSUserId) {
      raiseToast('error', 'Select CMS User')
      return
    }

    roleplayCall({
      data: {
        user_id: selectedCMSUserId,
        account_id: accountId,
      },
    })
  }
  return (
    <CModal visible={true} alignment="center">
      <CModalHeader>
        <CModalTitle>Select User for Roleplay</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CFormSelect
          value={selectedCMSUserId}
          onChange={(e) => {
            setSelectedCMSUserId(e.target.value)
          }}
        >
          <option value="" selected disabled>
            Select CMS User
          </option>
          {CMSUserData.map((info, idx) => (
            <option key={idx} value={info.id}>
              {info?.name + `  (${info?.roles.join(',')})`}
            </option>
          ))}
        </CFormSelect>
      </CModalBody>
      <CModalFooter>
        <CButton className="text-white" color="info" onClick={onClose}>
          Cancel
        </CButton>
        <CButton className="text-white" color="info" onClick={onStart}>
          Start
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default RoleplayModal
